import React from "react";

class ContentComponent extends React.Component {
  render() {
    return (
      <div className="main-container h-100 bg-main-body">
        <div class="card text-dark bg-white mb-3">
          <div class="card-body">
            <h5 class="card-title">Thanks for using this platform. </h5>

            <p class="card-text">
              For any queries or help, please drop us an email at:{" "}
              <span class="font-weight-bold ">
                {process.env.REACT_APP_CONTACT_EMAIL}
              </span>
              <div className="mt-2">
              You can also mail us at below address:{" "}
              <span class="font-weight-bold">
                enginEBogie, 25, Radha Swami Enclave, Prem Nagar, Bareilly, Uttar Pradesh - 243001.
              </span>
              </div>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ContentComponent;
